import { instance } from '../../../axios/AxiosInstance';

const PATH = 'single-table';

/** `POST /single-table` — creates a `setting` row. */
export async function createSingleTableRow(body: Record<string, unknown>): Promise<void> {
  await instance.post(PATH, body);
}

/** `PUT /single-table` — updates a `setting` row. */
export async function updateSingleTableRow(body: Record<string, unknown>): Promise<void> {
  await instance.put(PATH, body);
}
